"use client";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Copy, Code2 } from "lucide-react";
import { useTheme } from "next-themes";
import { Highlight, themes } from "prism-react-renderer";
import { useState, useEffect } from "react";
import { toast } from "sonner";
import { Button } from "../ui/button.js";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog.js";
import { cn } from "../../lib/utils.js";
export function ModelCodeExampleDialog(_a) {
  var _this = this;
  var modelId = _a.modelId;
  var _b = useState("curl"),
    activeTab = _b[0],
    setActiveTab = _b[1];
  var resolvedTheme = useTheme().resolvedTheme;
  var _c = useState(false),
    mounted = _c[0],
    setMounted = _c[1];
  useEffect(function () {
    setMounted(true);
  }, []);
  var codeExamples = {
    curl: {
      label: "cURL",
      language: "bash",
      code: "curl -X POST https://api.llmgateway.io/v1/chat/completions \\\n  -H \"Content-Type: application/json\" \\\n  -H \"Authorization: Bearer $LLM_GATEWAY_API_KEY\" \\\n  -d '{\n  \"model\": \"".concat(modelId, "\",\n  \"messages\": [\n    {\"role\": \"user\", \"content\": \"Hello, how are you?\"}\n  ]\n}'")
    },
    openai: {
      label: "OpenAI SDK",
      language: "typescript",
      code: "import OpenAI from \"openai\";\n\nconst client = new OpenAI({\n  apiKey: process.env.LLM_GATEWAY_API_KEY, // or your API key string\n  baseURL: \"https://api.llmgateway.io/v1/\"\n});\n\nconst response = await client.chat.completions.create({\n  model: \"".concat(modelId, "\",\n  messages: [\n    { role: \"user\", content: \"Hello, how are you?\" }\n  ]\n});\n\nconsole.log(response.choices[0].message.content);")
    },
    "ai-sdk": {
      label: "AI SDK",
      language: "typescript",
      code: "import { createLLMGateway } from \"@llmgateway/ai-sdk-provider\";\nimport { generateText } from \"ai\";\n\nconst llmgateway = createLLMGateway({ apiKey: process.env.LLM_GATEWAY_API_KEY });\n\nconst { text } = await generateText({\n  model: llmgateway(\"".concat(modelId, "\"),\n  prompt: \"Write a vegetarian lasagna recipe for 4 people.\",\n});")
    }
  };
  var currentExample = codeExamples[activeTab];
  var copyToClipboard = function (text, languageLabel) {
    return __awaiter(_this, void 0, void 0, function () {
      var err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, navigator.clipboard.writeText(text)];
          case 1:
            _a.sent();
            toast.success("Copied to clipboard", {
              description: "".concat(languageLabel, " example has been copied to your clipboard."),
              duration: 3000
            });
            return [3, 3];
          case 2:
            err_1 = _a.sent();
            console.error("Failed to copy text: ", err_1);
            toast.error("Copy failed", {
              description: "Could not copy to clipboard. Please try again.",
              duration: 3000
            });
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  };
  return _jsxs(Dialog, {
    children: [_jsx(DialogTrigger, {
      asChild: true,
      children: _jsx(Button, {
        variant: "ghost",
        size: "sm",
        className: "h-5 w-5 p-0",
        type: "button",
        "aria-label": "View code examples",
        children: _jsx(Code2, {
          className: "h-3 w-3"
        })
      })
    }), _jsxs(DialogContent, {
      className: "sm:max-w-2xl",
      children: [_jsxs(DialogHeader, {
        children: [_jsx(DialogTitle, {
          children: "Use this model with LLM Gateway"
        }), _jsxs(DialogDescription, {
          children: ["Code examples for", " ", _jsx("code", {
            className: "rounded bg-muted px-1.5 py-0.5 font-mono text-xs",
            children: modelId
          }), " ", "using cURL, the OpenAI SDK, and the AI SDK."]
        })]
      }), _jsxs("div", {
        className: "space-y-4",
        children: [_jsx("div", {
          className: "flex flex-wrap gap-2",
          children: Object.keys(codeExamples).map(function (key) {
            var example = codeExamples[key];
            return _jsx("button", {
              type: "button",
              onClick: function () {
                return setActiveTab(key);
              },
              className: cn("rounded-md px-3 py-1.5 text-xs font-medium transition-colors", activeTab === key ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground hover:bg-muted/80"),
              children: example.label
            }, key);
          })
        }), _jsxs("div", {
          className: "overflow-hidden rounded-md border bg-card",
          children: [_jsxs("div", {
            className: "flex items-center justify-between border-b bg-muted px-3 py-2",
            children: [_jsxs("span", {
              className: "text-xs font-medium text-muted-foreground",
              children: [currentExample.label, " example"]
            }), _jsxs(Button, {
              type: "button",
              variant: "ghost",
              size: "sm",
              className: "h-7 px-2 text-xs",
              onClick: function () {
                return copyToClipboard(currentExample.code, currentExample.label);
              },
              children: [_jsx(Copy, {
                className: "mr-1 h-3 w-3"
              }), "Copy"]
            })]
          }), _jsx("div", {
            className: "bg-background",
            children: _jsx(Highlight, {
              code: currentExample.code,
              language: currentExample.language,
              theme: mounted && resolvedTheme === "dark" ? themes.dracula : themes.github,
              children: function (_a_0) {
                var className = _a_0.className,
                  style = _a_0.style,
                  tokens = _a_0.tokens,
                  getLineProps = _a_0.getLineProps,
                  getTokenProps = _a_0.getTokenProps;
                return _jsx("pre", {
                  className: cn("max-h-80 overflow-auto p-4 text-xs leading-relaxed font-mono", className),
                  style: style,
                  children: tokens.map(function (line, i) {
                    var lineProps = getLineProps({
                      line: line
                    });
                    return _jsx("div", __assign({}, lineProps, {
                      children: line.map(function (token, key_0) {
                        var tokenProps = getTokenProps({
                          token: token
                        });
                        return _jsx("span", __assign({}, tokenProps), key_0);
                      })
                    }), i);
                  })
                });
              }
            })
          })]
        })]
      })]
    })]
  });
}